export const CREATE = 'visitors/CREATE';
export const SET = 'visitors/SET';